import React, { useEffect, useState, useRef } from "react";
import { withRouter } from "react-router-dom";
import { AppraiserCaseResult } from "interfaces/Mueller.Business.Models";
import { SearchResultDto } from "interfaces/BusinessModelsExtensions";
import { getAssignedCases } from "requests/appraiserCase";
import { MGrid, MSpinner } from "components/Shared";
import { clearNullFromColumnDefs } from "components/Shared/Functions";

interface Props {
  appraiserId: number;
  history: any; // from router
}

const AppraiserQueue = ({
  appraiserId,
  history,
} : Props) => {
  const mounted = useRef(true);

  const [caseData, setCaseData] = useState<SearchResultDto<AppraiserCaseResult>>(null);

  useEffect(() => {
    getAssignedCases(appraiserId, setCaseData, mounted);

    return () => {
      mounted.current = false;
    };
  }, []);

  const onCaseClicked = index => {
    history.push({
      pathname: "/case",
      state: {
        controlNumber: caseData.rows[index].controlIdNumber,
      }
    });
  };

  if (!caseData) return <MSpinner />;
  
  return (
    <div className="full-height">
      <MGrid
        columnDefinitions={clearNullFromColumnDefs(caseData.columns)}
        data={caseData.rows}
        onRowClick={onCaseClicked}
      />
    </div>
  );
};


export default withRouter(AppraiserQueue);